import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getUserAdmins = createAsyncThunk(
  "admin/allUserAdmins",
  async ({ page, limit, searchData ,user}, { rejectWithValue }) => {
    try {
      let url = `/user/all?page=${page}&limit=${limit}`;
      if (user) {
        url += `&userTypeFilter=${user}`;
      }

      if (searchData) {
        url += `&search=${searchData}`;
      }

      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const addUserAdmin = createAsyncThunk(
  "admin/addUserAdmin",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/user/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const editUserAdmin = createAsyncThunk(
  "admin/editUserAdmin",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/user/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getSingleUserAdmin = createAsyncThunk(
  "admin/singleUserAdmin",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/user/${userId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteUserAdmin = createAsyncThunk(
  "admin/deleteUserAdmin",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/user/delete/${selectedId}`,
        { headers: authHeader() }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  userAdminData: [],
  singleUserAdminData: [],
};

const userAdminSlice = createSlice({
  name: "userAdminSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserAdmins.fulfilled, (state, action) => {
      state.userAdminData = action.payload.data;
    });
    builder.addCase(getSingleUserAdmin.fulfilled, (state, action) => {
      state.singleUserAdminData = action.payload.data;
    });
  },
});

export default userAdminSlice.reducer;
